import { map, catchError } from 'rxjs/operators';
import { Http } from '@angular/http';
import { AppConfig } from './../config/app.config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private clientID: string;
  private configDirPath = 'config/';
  private envFile = 'env.json';
  private config: Object = null;
  private env: Object = null;

  constructor(private http: Http, public environment: AppConfig) {
  }

  getConfig(key: any) {
    return this.config[key];
  }

  init(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.configDirPath}${this.envFile}`)
        .pipe(
          map((res: any) => {
            return res.json();
          }),
          catchError((error: any): any => {
            console.log(
              `Configuration file '${this.configDirPath}${this.envFile}' could not be read`,
            );
            resolve(true);
            // tslint:disable-next-line: deprecation
            return Observable.throw(error.json().error || 'Server error');
          }),
        )
        .subscribe((envResponse: any) => {
          this.env = envResponse;
          let request: any = null;
          switch (envResponse.env) {
            case 'prod':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${
                    envResponse.env
                  }.json?${Math.random()}`,
                );
              }
              break;
            case 'qa':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`,
                );
              }
              break;
            case 'tst':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`,
                );
              }
              break;
            case 'dev':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`,
                );
              }
              break;
            case 'local':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`,
                );
              }
              break;
            case 'sbx':
              {
                request = this.http.get(
                  `${this.configDirPath}config.${envResponse.env}.json?${Math.random()}`,
                );
              }
              break;
            case 'default':
              {
                console.error('Environment file is not set or invalid');
                resolve(true);
              }
              break;
          }
          if (request) {
            request
              .pipe(
                map((res: any) => {
                  return res.json();
                }),
                catchError((error: any) => {
                  console.error(
                    `Error reading '${envResponse.env}' configuration file.`,
                  );
                  resolve(error);
                  // tslint:disable-next-line: deprecation
                  return Observable.throw(
                    error.json().error || 'Server error.',
                  );
                }),
              )
              .subscribe(responseData => {
                this.config = responseData;
                //console.log(`[CONFIG] Loaded config.${envResponse.env}.json:`, responseData);
                resolve(true);
              });
          } else {
            console.error('Env config file "env.json" is not valid.');
            resolve(true);
          }
        });
    });
  }

  sendClientID() {
      return this.clientID;
  }
}